<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { KenwoodItaly } from '../../modules/kenwood_italy_module.js'

export default {
  mixins: [fandomBasicMixin],
  data: function() {
    return {
      layout: globalState.pageModel.layout,
    };
  },
  mounted() {},
  methods: {
    isUserRegistered: Fandom.isUserRegistered,
    applyContextToUrl: Fandom.applyContextToUrl,
  }
};
</script>

<template>
  <div class="container-fluid" style="background-color: #fbbfa3;" stripe-invite-registration>
    <div class="container registration-footer">
      <a :href="content.link.url" class="link" v-if="content.link" :title="content.link.title"></a>
      <div class="row">
        <div class="col-12">
          <div class="invite-registration-modal__header">
            <p class="h3 text-center">
              {{content.title}}
            </p>
            <p class="h3 text-center text-orange">
              {{content.subtitle}}
            </p>
            <p class="invite-registration-modal__separator">
              <span class="invite-registration-modal__separator__title">{{content.separator_text}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="row pb-4">
        <div class="col-12 col-md" v-for="(element, index) in content.list" :key="`el-${index}`">
          <div class="icon mb-3">
            <img :src="element.icon.url" />
          </div>
          <div>
            <div class="invite-registration-modal__content-element__title" v-html="element.title"></div>
            <div class="invite-registration-modal__content-element__text" v-html="element.text"></div>
          </div>
        </div>
      </div>
      <div class="row pb-4" v-if="content.button">
        <div class="col-12 text-center mb-3">
          <a :href="content.button.url" :target="getTarget(content.button)" :class="content.button_class || 'btn-primary'" class="btn">
            {{content.button.title}}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[stripe-invite-registration] {
  .registration-footer {
    position: relative;

    .icon {
      img {
        margin: 0 auto;
        max-width: 100%;
        display: block;
      }
    }

    .link {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 1;
    }

    .invite-registration-modal__header {
      padding-top: 2rem;
      font-family: $bressay-font;
    }
    
    .invite-registration-modal__separator {
      height: 1px;
      background-color: #000;
      margin: 2rem 0;
      position: relative;

      span {
        padding: 0 1rem;
        background-color: #fbbfa3;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        font-family: Gotham,Helvetica,Arial,sans-serif;
        font-size: .75rem;
      }
    }
    
    .invite-registration-modal__content-element__title p,
    .invite-registration-modal__content-element__description p {
      text-align: center;
    }
    
    .invite-registration-modal__content-element__title p {
      font-size: 1.375rem; /* 22/16 */
      font-family: $bressay-font;
    }
    
    .invite-registration-modal__content-element__description p {
      font-size: 0.875rem;
    }
  }
}
</style>